(function () {
  const AX = (window.RB.AnimKit = window.RB.AnimKit || {});
  const { overlay, setText, STAG, EASE, SPAWN, Anim, dropPlaceholder, collapsePlaceholder, logFx, play, later, wall, anchorEl, anchorRect, pileOf, centerOf, clamp, fitsCard, tf, peelPile, bumpPile, tickPlate } = AX;

  const LATER_WHEN = {
    endOfTurn: "at end of turn", beginningPhase: "next beginning phase", startOfTurn: "next turn",
    endOfCombat: "when combat ends", combatEnd: "when combat ends",
  };

  function mkBanner(text, big, dur, cls) {
    overlay((big ? "fxbig" : "fxbanner") + (cls ? " " + cls : ""), dur + 60, function (b) {
      setText(b, text);
      b.style.animationDuration = wall(dur) + "ms";
    });
  }

  function spriteStyles(e, card, crop, artW) {
    if (RB.hasArt(card) && crop === "rune") {
      e.style.backgroundImage = RB.artCssAt(card, artW || 170);
      e.style.backgroundSize = "auto 192%";
      e.style.backgroundPosition = "50% 17%";
    } else if (RB.hasArt(card) && crop !== "back") {
      e.style.backgroundImage = RB.artCssAt(card, artW || 112);
      e.style.backgroundSize = "cover";
      e.style.backgroundPosition = "center";
    } else {
      e.classList.add("back");
    }
  }

  function buildCard(s, w, h) {
    const box = document.createElement("div");
    box.className = "flycard";
    box.style.width = w + "px";
    box.style.height = h + "px";
    if (!s.flip) {
      spriteStyles(box, s.card, s.crop, s.artW);
      return { box: box, inner: null, front: null };
    }
    box.classList.add("flip");
    const inner = document.createElement("div");
    inner.className = "flipinner";
    const front = document.createElement("div");
    front.className = "flipface";
    spriteStyles(front, s.card, s.crop === "back" ? "full" : s.crop, s.artW);
    front.classList.remove("back");
    const sheen = document.createElement("div");
    sheen.className = "fxsheen";
    front.appendChild(sheen);
    const back = document.createElement("div");
    back.className = "flipface backside";
    inner.appendChild(front);
    inner.appendChild(back);
    box.appendChild(inner);
    return { box: box, inner: inner, front: front, sheen: sheen };
  }

  function flipFrames(dirToFace) {
    if (dirToFace) {
      return [
        { transform: "rotateY(180deg)" },
        { transform: "rotateY(180deg)", offset: 0.36, easing: EASE.flip },
        { transform: "rotateY(0deg)", offset: 0.62 },
        { transform: "rotateY(0deg)" },
      ];
    }
    return [
      { transform: "rotateY(0deg)" },
      { transform: "rotateY(0deg)", offset: 0.03, easing: EASE.flip },
      { transform: "rotateY(180deg)", offset: 0.28 },
      { transform: "rotateY(180deg)" },
    ];
  }

  function sheenFrames() {
    return [
      { opacity: 0, transform: "translateX(-80%) skewX(-6deg)" },
      { opacity: 0, transform: "translateX(-80%) skewX(-6deg)", offset: 0.54 },
      { opacity: 1, transform: "translateX(0%) skewX(-6deg)", offset: 0.66 },
      { opacity: 0, transform: "translateX(80%) skewX(-6deg)", offset: 0.81 },
      { opacity: 0, transform: "translateX(80%) skewX(-6deg)" },
    ];
  }

  function landGlow(b, w, dur) {
    const l = Anim.layer();
    const g = document.createElement("div");
    g.className = "fxland";
    g.style.width = Math.round(w * 1.05) + "px";
    g.style.left = (b.x - w * 0.525) + "px";
    g.style.top = b.y + "px";
    l.appendChild(g);
    play(g, [
      { opacity: 0, transform: "scaleX(.45)" },
      { opacity: .9, transform: "scaleX(1.05)", offset: 0.28 },
      { opacity: 0, transform: "scaleX(1.35)" },
    ], { duration: 320, delay: Math.max(0, dur - 90), easing: "ease-out", fill: "backwards" });
    later(function () { g.remove(); }, dur + 320);
  }

  function runArc(s, dur) {
    if (s.text) mkBanner(s.text, false, dur, s.cls);
    const from = anchorRect(s.from);
    const to = anchorRect(s.to);
    if (!from || !to) return;

    const src = fitsCard(from) ? from : null;
    const dst = fitsCard(to) ? to : null;
    const portrait = function (r) { return r && r.height >= r.width * 1.2; };
    const ref = portrait(src) ? src : portrait(dst) ? dst : src || dst;
    const w = ref ? (portrait(ref) ? ref.width : Math.round(ref.height / 1.4)) : 62;
    const h = ref ? (portrait(ref) ? ref.height : ref.height) : 86;
    const scaleTo = function (r) { return r ? Math.max(0.3, Math.min(2.4, Math.min(r.width / w, r.height / h))) : 1; };
    const k0 = src && dst ? scaleTo(src) : 1;
    const kEnd = dst ? scaleTo(dst) : 1;

    const a = centerOf(from), b = centerOf(to);
    b.x += s.dx || 0;
    b.y += s.dy || 0;
    const dx = a.x - b.x, dy = a.y - b.y;

    const built = buildCard(s, w, h);
    const box = built.box;
    box.style.left = (b.x - w / 2) + "px";
    box.style.top = (b.y - h / 2) + "px";
    Anim.layer().appendChild(box);

    const srcPile = pileOf(s.from);
    const dstPile = pileOf(s.to);
    const srcHost = anchorEl(s.from);
    const dstHost = anchorEl(s.to);

    if (Anim.flat()) {
      play(box, [{ opacity: 0 }, { opacity: 1, offset: 0.35 }, { opacity: 0 }], { duration: dur });
      if (srcHost) tickPlate(srcHost, 0, s.tickCls);
      if (dstHost) tickPlate(dstHost, dur * 0.6, s.tickCls);
      later(function () { box.remove(); }, dur + 40);
      return;
    }

    if (srcPile) peelPile(srcPile, Math.round(dur * 0.3));
    if (srcHost) tickPlate(srcHost, Math.round(dur * 0.08), s.tickCls);
    if (dstPile) bumpPile(dstPile, Math.round(dur * 0.94));
    if (dstHost && dstHost !== srcHost) tickPlate(dstHost, Math.round(dur * 0.92), s.tickCls);

    const dist = Math.sqrt(dx * dx + dy * dy);
    const apex = Math.max(22, Math.min(92, dist * 0.36));
    const dir = dx >= 0 ? 1 : -1;
    const lean = -8 * dir;
    const lift = -Math.min(12, h * 0.12);
    const midScale = Math.max(k0, kEnd, 1) * 1.01;

    play(box, [
      { opacity: 0, transform: tf(dx, dy, 0, k0), easing: "linear" },
      { opacity: 1, transform: tf(dx, dy, 0, k0), offset: 0.05, easing: EASE.peel },
      { opacity: 1, transform: tf(dx + dir, dy + lift, lean * 0.5, k0 * 1.02), offset: 0.16, easing: EASE.arc },
      { transform: tf(dx * 0.5, dy * 0.5 - apex, lean, midScale), offset: 0.56, easing: EASE.apex },
      { transform: tf(0, 9, -lean * 0.38, kEnd * 1.045), offset: 0.86, easing: EASE.settle },
      { opacity: 1, transform: tf(0, 0, 0, kEnd) },
    ], { duration: dur, fill: "forwards" });

    if (built.inner) {
      play(built.inner, flipFrames(s.flip === "toFace"), { duration: dur, fill: "forwards" });
      if (s.flip === "toFace" && built.sheen) {
        play(built.sheen, sheenFrames(), { duration: dur, easing: "ease-out", fill: "forwards" });
      }
    }
    if (dst && !dstPile) landGlow(b, w, dur);
    later(function () { box.remove(); }, dur + 24);
  }

  function runHoldArc(s, dur) {
    if (s.text) mkBanner(s.text, false, dur, s.cls);
    const from = anchorRect(s.from);
    const to = anchorRect(s.to);
    if (!from || !to) { runArc(s, dur); return; }
    if (Anim.flat()) { runArc(s, dur); return; }

    const src = fitsCard(from) ? from : null;
    const dst = fitsCard(to) ? to : null;
    const w = dst ? dst.width : src ? src.width : 62;
    const h = dst ? dst.height : src ? src.height : 86;
    const k0 = src && dst ? Math.max(0.3, Math.min(2.4, src.width / dst.width)) : 1;

    const a = centerOf(from), b = centerOf(to);
    const dx = a.x - b.x, dy = a.y - b.y;
    const mid = viewportCenter();
    const cx = mid.x - b.x;
    const cy = mid.y - b.y;
    const big = s.hold && s.hold.scale ? s.hold.scale : 1.5;

    const dim = document.createElement("div");
    dim.className = "fxdim";
    Anim.layer().appendChild(dim);
    play(dim, [
      { opacity: 0 },
      { opacity: 1, offset: 0.3 },
      { opacity: 1, offset: 0.66 },
      { opacity: 0, offset: 0.82 },
      { opacity: 0 },
    ], { duration: dur, fill: "forwards" });

    const built = buildCard(s, w, h);
    const box = built.box;
    box.classList.add("burnfly");
    box.style.left = (b.x - w / 2) + "px";
    box.style.top = (b.y - h / 2) + "px";
    Anim.layer().appendChild(box);

    const srcPile = pileOf(s.from);
    const dstPile = pileOf(s.to);
    if (srcPile) peelPile(srcPile, Math.round(dur * 0.2));
    tickPlate(anchorEl(s.from), Math.round(dur * 0.05), s.tickCls);
    if (dstPile) bumpPile(dstPile, Math.round(dur * 0.96));
    tickPlate(anchorEl(s.to), Math.round(dur * 0.94), "fxtick-bad");

    play(box, [
      { opacity: 0, transform: tf(dx, dy, 0, k0), easing: "linear" },
      { opacity: 1, transform: tf(dx, dy, 0, k0), offset: 0.04, easing: EASE.peel },
      { opacity: 1, transform: tf(dx, dy - 10, -4, k0 * 1.02), offset: 0.1, easing: EASE.arc },
      { transform: tf(cx + (dx - cx) * 0.4, cy - 42, -6, (k0 + big) / 2), offset: 0.24, easing: EASE.apex },
      { transform: tf(cx, cy, 0, big), offset: 0.36, easing: "ease-in-out" },
      { transform: tf(cx, cy - 5, 0, big), offset: 0.62, easing: EASE.fall },
      { transform: tf(cx * 0.55, cy * 0.4, 9, big * 0.8), offset: 0.79, easing: EASE.fall },
      { opacity: 1, transform: tf(0, 0, 14, 1), offset: 0.94, easing: EASE.settle },
      { opacity: 1, transform: tf(0, 0, 9, 1) },
    ], { duration: dur, fill: "forwards" });

    if (built.inner) {
      play(built.inner, [
        { transform: "rotateY(180deg)" },
        { transform: "rotateY(180deg)", offset: 0.13, easing: EASE.flip },
        { transform: "rotateY(0deg)", offset: 0.28 },
        { transform: "rotateY(0deg)" },
      ], { duration: dur, fill: "forwards" });
      if (built.sheen) {
        play(built.sheen, [
          { opacity: 0, transform: "translateX(-80%) skewX(-6deg)" },
          { opacity: 0, transform: "translateX(-80%) skewX(-6deg)", offset: 0.22 },
          { opacity: 1, transform: "translateX(0%) skewX(-6deg)", offset: 0.3 },
          { opacity: 0, transform: "translateX(80%) skewX(-6deg)", offset: 0.4 },
          { opacity: 0, transform: "translateX(80%) skewX(-6deg)" },
        ], { duration: dur, easing: "ease-out", fill: "forwards" });
      }
    }

    const ember = document.createElement("div");
    ember.className = "fxember";
    ember.style.left = (b.x - w / 2 - 5) + "px";
    ember.style.top = (b.y - h / 2 - 5) + "px";
    ember.style.width = (w + 10) + "px";
    ember.style.height = (h + 10) + "px";
    Anim.layer().appendChild(ember);
    play(ember, [
      { opacity: 0 }, { opacity: 1, offset: 0.15 }, { opacity: 0 },
    ], { duration: 420, delay: Math.round(dur * 0.93), easing: "ease-out", fill: "backwards" });

    later(function () { box.remove(); }, dur + 24);
    later(function () { dim.remove(); ember.remove(); }, dur + 360);
  }

  function spawnBurst(b, w, style, dur) {
    const l = Anim.layer();
    const dead = [];
    const halo = document.createElement("div");
    halo.className = "fxburst";
    halo.style.width = Math.round(w * 2.1) + "px";
    halo.style.height = Math.round(w * 2.1) + "px";
    halo.style.left = b.x + "px";
    halo.style.top = b.y + "px";
    if (style.core) halo.style.background =
      "radial-gradient(closest-side, " + style.core + ", " + style.tint + "88 42%, " + style.tint + "00 72%)";
    l.appendChild(halo);
    dead.push(halo);
    play(halo, [
      { opacity: 0, transform: "translate(-50%,-50%) scale(.15)" },
      { opacity: .95, transform: "translate(-50%,-50%) scale(.8)", offset: 0.22 },
      { opacity: 0, transform: "translate(-50%,-50%) scale(" + style.burst + ")" },
    ], { duration: Math.round(dur * 0.85), easing: EASE.arc, fill: "both" });

    for (let i = 0; i < style.motes; i++) {
      const ang = (Math.PI * 2 * i) / style.motes + (style.spin > 20 ? 0.31 : 0);
      const reach = w * (1.1 + (i % 3) * 0.22);
      const m = document.createElement("div");
      m.className = "fxmote";
      m.style.left = b.x + "px";
      m.style.top = b.y + "px";
      if (style.core) {
        m.style.background = "radial-gradient(closest-side, " + style.core + ", " + style.tint + ")";
        m.style.boxShadow = "0 0 8px " + style.tint;
      }
      l.appendChild(m);
      dead.push(m);
      play(m, [
        { opacity: 0, transform: "translate(-50%,-50%) scale(.4)" },
        { opacity: 1, transform: "translate(-50%,-50%) translate(" + (Math.cos(ang) * reach * 0.35) + "px," + (Math.sin(ang) * reach * 0.35) + "px) scale(1.15)", offset: 0.3 },
        { opacity: 0, transform: "translate(-50%,-50%) translate(" + (Math.cos(ang) * reach) + "px," + (Math.sin(ang) * reach + w * 0.28) + "px) scale(.35)" },
      ], { duration: Math.round(dur * 0.9), delay: 30 + (i % 4) * 26, easing: "ease-out", fill: "both" });
    }
    later(function () { for (const e of dead) e.remove(); }, dur + 420);
  }

  function runSpawn(s, dur) {
    if (s.text) mkBanner(s.text, false, dur, s.cls);
    const to = anchorRect(s.to);
    if (!to) return;
    const style = SPAWN[s.flavor] || SPAWN.token;
    const portrait = to.height >= to.width * 1.2;
    const fits = fitsCard(to);
    const w = fits ? (portrait ? to.width : Math.round(to.height / 1.4)) : 62;
    const h = fits ? to.height : 86;
    const b = centerOf(to);

    const built = buildCard(s, w, h);
    const box = built.box;
    box.classList.add("spawnfly");
    box.style.left = (b.x - w / 2) + "px";
    box.style.top = (b.y - h / 2) + "px";
    Anim.layer().appendChild(box);

    const host = anchorEl(s.to);

    if (Anim.flat()) {
      play(box, [{ opacity: 0 }, { opacity: 1, offset: 0.4 }, { opacity: 0 }], { duration: dur });
      if (host) tickPlate(host, Math.round(dur * 0.5), s.tickCls);
      later(function () { box.remove(); }, dur + 40);
      return;
    }

    play(box, [
      { opacity: 0, transform: tf(0, -h * 0.12, style.spin, 0.2), easing: EASE.arc },
      { opacity: 1, transform: tf(0, -h * 0.06, style.spin * 0.35, 1.16), offset: 0.4, easing: EASE.settle },
      { opacity: 1, transform: tf(0, 0, 0, 0.96), offset: 0.7, easing: EASE.fall },
      { opacity: 1, transform: tf(0, 0, 0, 1) },
    ], { duration: dur, fill: "forwards" });

    spawnBurst(b, w, style, dur);

    for (let i = 0; i < 2; i++) {
      const ring = AX.fxBox("fxring", to, 5 + i * 5);
      ring.style.borderColor = style.tint;
      play(ring, [
        { opacity: 0, transform: "scale(.35)" },
        { opacity: .85, transform: "scale(1)", offset: 0.35 },
        { opacity: 0, transform: "scale(1.7)" },
      ], { duration: Math.round(dur * 0.7), delay: i * 110, easing: "ease-out", fill: "both" });
      later(function () { ring.remove(); }, dur + 200);
    }

    if (host) tickPlate(host, Math.round(dur * 0.5), s.tickCls);
    landGlow(b, w, dur);
    later(function () { box.remove(); }, dur + 24);
  }

  function runMorph(s, dur) {
    if (s.text) mkBanner(s.text, false, dur, s.cls);
    const from = anchorRect(s.from);
    const to = anchorRect(s.to);
    if (!from || !to) return;

    const toRune = s.dir === "toRune";
    const cardR = toRune ? from : to;
    const runeR = toRune ? to : from;
    const cw = fitsCard(cardR) ? cardR.width : 26;
    const ch = fitsCard(cardR) ? cardR.height : 36;
    const rw = fitsCard(runeR) ? runeR.width : 26;
    const rh = fitsCard(runeR) ? runeR.height : 36;
    const a = centerOf(from), b = centerOf(to);

    const box = document.createElement("div");
    box.className = "flycard flip morphfly";
    const inner = document.createElement("div");
    inner.className = "flipinner";
    const front = document.createElement("div");
    front.className = "flipface";
    if (RB.hasArt(s.card)) {
      front.style.backgroundImage = RB.artCssAt(s.card, 112);
      front.style.backgroundSize = "cover";
      front.style.backgroundPosition = "center";
    }
    const crop = document.createElement("div");
    crop.className = "fxcrop";
    if (RB.hasArt(s.card)) crop.style.backgroundImage = RB.artCssAt(s.card, 200);
    front.appendChild(crop);
    const back = document.createElement("div");
    back.className = "flipface backside";
    inner.appendChild(front);
    inner.appendChild(back);
    box.appendChild(inner);
    if (s.domain) box.style.setProperty("--fxdomain", domainColor(s.domain));
    Anim.layer().appendChild(box);

    const startBox = toRune
      ? { l: a.x - cw / 2, t: a.y - ch / 2, w: cw, h: ch, r: 9 }
      : { l: a.x - rw / 2, t: a.y - rh / 2, w: rw, h: rh, r: 5 };
    const endBox = toRune
      ? { l: b.x - rw / 2, t: b.y - rh / 2, w: rw, h: rh, r: 5 }
      : { l: b.x - cw / 2, t: b.y - ch / 2, w: cw, h: ch, r: 9 };

    if (Anim.flat()) {
      box.style.left = endBox.l + "px"; box.style.top = endBox.t + "px";
      box.style.width = endBox.w + "px"; box.style.height = endBox.h + "px";
      play(box, [{ opacity: 0 }, { opacity: 1, offset: 0.4 }, { opacity: 0 }], { duration: dur });
      tickPlate(anchorEl(s.to), dur * 0.6, s.tickCls);
      later(function () { box.remove(); }, dur + 40);
      return;
    }

    const midX = (startBox.l + endBox.l) / 2;
    const apex = Math.max(26, Math.min(80, Math.abs(a.x - b.x) * 0.3));
    const midY = Math.min(startBox.t, endBox.t) - apex;
    const midW = Math.round((cw + rw) / 2);
    const midH = Math.round((ch + rh) / 2);

    const srcPile = pileOf(s.from);
    const dstPile = pileOf(s.to);
    if (srcPile) peelPile(srcPile, Math.round(dur * 0.3));
    if (dstPile) bumpPile(dstPile, Math.round(dur * 0.94));
    tickPlate(anchorEl(s.from), Math.round(dur * 0.08), s.tickCls);
    tickPlate(anchorEl(s.to), Math.round(dur * 0.92), s.tickCls);

    const frames = toRune ? [
      { opacity: 0, left: startBox.l + "px", top: startBox.t + "px", width: startBox.w + "px", height: startBox.h + "px", borderRadius: "9px", easing: "linear" },
      { opacity: 1, left: startBox.l + "px", top: startBox.t + "px", width: startBox.w + "px", height: startBox.h + "px", borderRadius: "9px", offset: 0.04, easing: EASE.peel },
      { opacity: 1, left: (startBox.l + 3) + "px", top: (startBox.t - 10) + "px", width: startBox.w + "px", height: startBox.h + "px", borderRadius: "9px", offset: 0.14, easing: EASE.arc },
      { left: midX + "px", top: midY + "px", width: startBox.w + "px", height: startBox.h + "px", borderRadius: "9px", offset: 0.52, easing: EASE.apex },
      { left: (endBox.l + (midX - endBox.l) * 0.34) + "px", top: (endBox.t - apex * 0.34) + "px", width: midW + "px", height: midH + "px", borderRadius: "22%", offset: 0.76, easing: EASE.arc },
      { left: (endBox.l - 2) + "px", top: (endBox.t - 3) + "px", width: (endBox.w + 5) + "px", height: (endBox.h + 5) + "px", borderRadius: "5px", offset: 0.93, easing: EASE.settle },
      { opacity: 1, left: endBox.l + "px", top: endBox.t + "px", width: endBox.w + "px", height: endBox.h + "px", borderRadius: "5px" },
    ] : [
      { opacity: 1, left: startBox.l + "px", top: startBox.t + "px", width: startBox.w + "px", height: startBox.h + "px", borderRadius: "5px", easing: EASE.peel },
      { opacity: 1, left: (startBox.l - 2) + "px", top: (startBox.t - 8) + "px", width: (startBox.w + 5) + "px", height: (startBox.h + 5) + "px", borderRadius: "5px", offset: 0.1, easing: EASE.arc },
      { left: midX + "px", top: midY + "px", width: midW + "px", height: midH + "px", borderRadius: "22%", offset: 0.46, easing: EASE.apex },
      { left: (endBox.l + (midX - endBox.l) * 0.3) + "px", top: (endBox.t - apex * 0.3) + "px", width: endBox.w + "px", height: endBox.h + "px", borderRadius: "9px", offset: 0.76, easing: EASE.fall },
      { opacity: 1, left: endBox.l + "px", top: endBox.t + "px", width: endBox.w + "px", height: endBox.h + "px", borderRadius: "9px", offset: 0.94 },
      { opacity: 0, left: endBox.l + "px", top: endBox.t + "px", width: endBox.w + "px", height: endBox.h + "px", borderRadius: "9px" },
    ];
    play(box, frames, { duration: dur, fill: "forwards" });

    play(inner, toRune ? [
      { transform: "rotateY(180deg)" },
      { transform: "rotateY(180deg)", offset: 0.3, easing: EASE.flip },
      { transform: "rotateY(0deg)", offset: 0.52 },
      { transform: "rotateY(0deg)" },
    ] : [
      { transform: "rotateY(0deg)" },
      { transform: "rotateY(0deg)", offset: 0.08, easing: EASE.flip },
      { transform: "rotateY(180deg)", offset: 0.34 },
      { transform: "rotateY(180deg)" },
    ], { duration: dur, fill: "forwards" });

    play(crop, toRune
      ? [{ opacity: 0 }, { opacity: 0, offset: 0.6 }, { opacity: 1, offset: 0.86 }, { opacity: 1 }]
      : [{ opacity: 1 }, { opacity: 1, offset: 0.1 }, { opacity: 0, offset: 0.34 }, { opacity: 0 }],
      { duration: dur, fill: "forwards" });

    if (toRune) {
      const ring = document.createElement("div");
      ring.className = "fxring";
      ring.style.left = (b.x - rw) + "px";
      ring.style.top = (b.y - rh) + "px";
      ring.style.width = (rw * 2) + "px";
      ring.style.height = (rh * 2) + "px";
      if (s.domain) ring.style.borderColor = domainColor(s.domain);
      Anim.layer().appendChild(ring);
      play(ring, [
        { opacity: 0, transform: "scale(.45)" },
        { opacity: .95, transform: "scale(.8)", offset: 0.25 },
        { opacity: 0, transform: "scale(1.35)" },
      ], { duration: 420, delay: Math.round(dur * 0.9), easing: "ease-out", fill: "backwards" });
      later(function () { ring.remove(); }, dur + 460);
    }

    if (s.pip) runPip(s.pip, b, dur, s.domain);
    later(function () { box.remove(); }, dur + 40);
  }

  function runPip(pip, from, dur, domain) {
    const to = anchorRect(pip.to);
    if (!to) return;
    const b = centerOf(to);
    const e = document.createElement("div");
    e.className = "fxpip";
    setText(e, pip.text);
    if (domain) e.style.color = domainColor(domain);
    e.style.left = b.x + "px";
    e.style.top = b.y + "px";
    Anim.layer().appendChild(e);
    const dx = from.x - b.x, dy = from.y - b.y - 40;
    play(e, [
      { opacity: 0, transform: "translate(" + dx + "px," + dy + "px) scale(.5)", easing: EASE.arc },
      { opacity: 1, transform: "translate(" + dx + "px," + (dy - 8) + "px) scale(1.15)", offset: 0.14, easing: EASE.arc },
      { opacity: 1, transform: "translate(0,0) scale(1)", offset: 0.72, easing: EASE.fall },
      { opacity: 0, transform: "translate(0,-6px) scale(.65)" },
    ], { duration: Math.round(dur * 0.9), delay: Math.round(dur * 0.45), fill: "backwards" });
    tickPlate(anchorEl(pip.to), Math.round(dur * 1.05), "fxtick-good");
    later(function () { e.remove(); }, dur * 2);
  }

  function domainColor(d) {
    const map = {
      fury: "#ff7b6b", calm: "#7bd88f", mind: "#6bb7ff",
      body: "#ffab5e", chaos: "#c98bff", order: "#ffe95e",
    };
    return map[String(d).toLowerCase()] || "#f0c46a";
  }

  function runShuffle(s, dur) {
    const host = anchorEl({ anchor: "deck-" + s.player });
    const stack = host ? host.querySelector(".pilestack") : null;
    if (!stack || Anim.flat()) {
      if (host) tickPlate(host, 0);
      return;
    }
    const r = stack.getBoundingClientRect();
    if (!r.width) return;
    const l = Anim.layer();
    const halves = [];
    const bars = [];
    for (let i = 0; i < 2; i++) {
      const c = stack.cloneNode(true);
      c.className = "fxshufhalf";
      c.style.left = r.left + "px";
      c.style.top = r.top + "px";
      c.style.width = r.width + "px";
      c.style.height = r.height + "px";
      l.appendChild(c);
      halves.push(c);
    }
    stack.style.visibility = "hidden";
    const restore = function () {
      stack.style.visibility = "";
      for (const c of halves) c.remove();
      for (const bar of bars) bar.remove();
    };
    Anim._cleanup.push(restore);
    tickPlate(host, 0);

    const out = Math.round(r.width * 0.95);
    play(halves[1], [
      { transform: "translate(0,0) rotate(0deg) scale(1)", easing: EASE.peel },
      { transform: "translate(0,-9px) rotate(0deg) scale(1.05)", offset: 0.07, easing: EASE.arc },
      { transform: "translate(" + out + "px,-12px) rotate(7deg) scale(1.05)", offset: 0.17, easing: EASE.apex },
      { transform: "translate(" + Math.round(out * 0.4) + "px,-16px) rotate(4deg) scale(1.03)", offset: 0.31, easing: EASE.fall },
      { transform: "translate(0,0) rotate(0deg) scale(1)", offset: 0.43, easing: EASE.peel },
      { transform: "translate(0,-9px) rotate(0deg) scale(1.05)", offset: 0.51, easing: EASE.arc },
      { transform: "translate(-" + out + "px,-12px) rotate(-7deg) scale(1.05)", offset: 0.61, easing: EASE.apex },
      { transform: "translate(-" + Math.round(out * 0.4) + "px,-16px) rotate(-4deg) scale(1.03)", offset: 0.75, easing: EASE.fall },
      { transform: "translate(0,0) rotate(0deg) scale(1)", offset: 0.875 },
      { transform: "translate(2px,0) rotate(.8deg) scale(1)", offset: 0.91 },
      { transform: "translate(-2px,0) rotate(-.8deg) scale(1)", offset: 0.945 },
      { transform: "translate(0,0) rotate(0deg) scale(1)" },
    ], { duration: dur, fill: "forwards" });

    play(halves[0], [
      { transform: "translate(0,0) rotate(0deg)", easing: EASE.arc },
      { transform: "translate(-6px,1px) rotate(-1.4deg)", offset: 0.19, easing: EASE.settle },
      { transform: "translate(0,0) rotate(0deg)", offset: 0.3 },
      { transform: "translate(0,2px) rotate(0deg)", offset: 0.45, easing: EASE.settle },
      { transform: "translate(0,0) rotate(0deg)", offset: 0.53, easing: EASE.arc },
      { transform: "translate(6px,1px) rotate(1.4deg)", offset: 0.63, easing: EASE.settle },
      { transform: "translate(0,0) rotate(0deg)", offset: 0.76 },
      { transform: "translate(0,2px) rotate(0deg)", offset: 0.89, easing: EASE.settle },
      { transform: "translate(0,0) rotate(0deg)" },
    ], { duration: dur, fill: "forwards" });

    for (let i = 0; i < 6; i++) {
      const bar = document.createElement("div");
      bar.className = "fxriffle";
      bar.style.left = r.left + "px";
      bar.style.width = r.width + "px";
      bar.style.top = (r.top + 14 + i * (r.height - 28) / 5) + "px";
      l.appendChild(bar);
      bars.push(bar);
      play(bar, [
        { opacity: 0, transform: "translateX(-18px) scaleX(.55)", easing: EASE.peel },
        { opacity: .95, transform: "translateX(0) scaleX(1)", offset: 0.35, easing: EASE.fall },
        { opacity: 0, transform: "translateX(16px) scaleX(.55)" },
      ], { duration: 190, delay: Math.round(dur * 0.63) + i * 26, fill: "backwards" });
    }

    later(function () {
      restore();
      const i = Anim._cleanup.indexOf(restore);
      if (i >= 0) Anim._cleanup.splice(i, 1);
    }, dur + 40);
  }

  function runRevealFan(s, dur) {
    dockHeld();
    const l = Anim.layer();
    const n = s.cards.length;
    if (!n) return;
    const from = anchorRect(s.from);
    const f = field();
    const a = from ? centerOf(from) : { x: f.left + f.width / 2, y: f.top + f.height + 60 };
    const srcPile = pileOf(s.from);

    let w = 86, h = 120;
    const gap = 10;
    const maxW = f.width * 0.86;
    if (n * w + (n - 1) * gap > maxW) {
      w = Math.max(52, Math.floor((maxW - (n - 1) * gap) / n));
      h = Math.round(w * 1.4);
    }
    const total = n * w + (n - 1) * gap;
    const x0 = Math.round(f.left + (f.width - total) / 2);
    const cy = Math.round(f.top + f.height * 0.4);
    const spread = Math.min(9, 22 / n);

    const dealMs = Math.round(dur * 0.16);
    const holdEnd = Math.round(dur * 0.78);
    const collectMs = Math.round(dur * 0.14);
    const stag = Math.min(STAG.deal, Math.round(dealMs * 0.3));

    if (s.text) {
      const cap = document.createElement("div");
      cap.className = "fxrevealcap";
      setText(cap, s.text);
      cap.style.top = (cy - h / 2 - 34) + "px";
      l.appendChild(cap);
      play(cap, [
        { opacity: 0 }, { opacity: 1, offset: 0.06 },
        { opacity: 1, offset: 0.84 }, { opacity: 0 },
      ], { duration: dur, easing: "ease", fill: "forwards" });
      later(function () { cap.remove(); }, dur + 60);
    }

    for (let i = 0; i < n; i++) {
      const card = s.cards[i];
      const rot = n === 1 ? 0 : (i - (n - 1) / 2) * spread;
      const drop = Math.abs(i - (n - 1) / 2) * (h * 0.07);
      const restL = x0 + i * (w + gap);
      const restT = cy - h / 2 + drop;
      const dx = a.x - (restL + w / 2);
      const dy = a.y - (restT + h / 2);
      const k0 = from && from.width ? Math.max(0.4, Math.min(2, from.width / w)) : 1;

      const box = document.createElement("div");
      box.className = "fxrevealcard";
      box.style.width = w + "px";
      box.style.height = h + "px";
      box.style.left = restL + "px";
      box.style.top = restT + "px";
      const float = document.createElement("div");
      float.className = "fxfloat";
      const inner = document.createElement("div");
      inner.className = "flipinner";
      const front = document.createElement("div");
      front.className = "flipface";
      if (RB.hasArt(card)) {
        front.style.backgroundImage = RB.artCssAt(card, 112);
        front.style.backgroundSize = "cover";
        front.style.backgroundPosition = "center";
      }
      const back = document.createElement("div");
      back.className = "flipface backside";
      inner.appendChild(front);
      inner.appendChild(back);
      float.appendChild(inner);
      box.appendChild(float);
      l.appendChild(box);

      if (Anim.flat()) {
        play(box, [{ opacity: 0 }, { opacity: 1, offset: 0.12 }, { opacity: 1, offset: 0.85 }, { opacity: 0 }],
          { duration: dur, fill: "forwards" });
        later(function () { box.remove(); }, dur + 40);
        continue;
      }

      const dealAt = i * stag;
      const backAt = holdEnd + (n - 1 - i) * STAG.collect;
      const apex = Math.max(30, Math.min(120, Math.sqrt(dx * dx + dy * dy) * 0.3));

      play(box, [
        { opacity: 0, transform: tf(dx, dy, 0, k0), easing: "linear" },
        { opacity: 1, transform: tf(dx, dy, 0, k0), offset: 0.06, easing: EASE.peel },
        { opacity: 1, transform: tf(dx + 1, dy - 11, -3, k0 * 1.01), offset: 0.2, easing: EASE.arc },
        { transform: tf(dx * 0.45, dy * 0.3 - apex, rot - 7, (k0 + 1) / 2), offset: 0.62, easing: EASE.apex },
        { transform: tf(0, 10, rot - 2, 1.04), offset: 0.86, easing: EASE.settle },
        { opacity: 1, transform: tf(0, 0, rot, 1) },
      ], { duration: dealMs, delay: dealAt, fill: "both" });

      play(inner, flipFrames(s.face !== false), { duration: dealMs, delay: dealAt, fill: "both" });

      play(float, [
        { transform: "translateY(0)" },
        { transform: "translateY(-3px)", offset: 0.25 },
        { transform: "translateY(1px)", offset: 0.55 },
        { transform: "translateY(-2px)", offset: 0.8 },
        { transform: "translateY(0)" },
      ], {
        duration: Math.max(400, holdEnd - dealAt - dealMs), delay: dealAt + dealMs,
        easing: "ease-in-out", iterations: 1, fill: "backwards",
      });

      play(box, [
        { transform: tf(0, 0, rot, 1), easing: EASE.arc },
        { transform: tf(0, -13, rot, 1.03), offset: 0.18, easing: EASE.apex },
        { transform: tf(dx * 0.5, dy * 0.28 - apex * 0.5, rot * 0.4, (k0 + 1) / 2 * 1.05), offset: 0.62, easing: EASE.fall },
        { opacity: 1, transform: tf(dx, dy, 0, k0), offset: 0.94 },
        { opacity: 0, transform: tf(dx, dy, 0, k0) },
      ], { duration: collectMs, delay: backAt, fill: "forwards" });

      play(inner, flipFrames(false), { duration: collectMs, delay: backAt, fill: "forwards" });

      if (srcPile) bumpPile(srcPile, backAt + collectMs);
      later(function () { box.remove(); }, dur + 80);
    }

    if (srcPile) {
      for (let i = 0; i < n; i++) {
        const gen = Anim._gen;
        later(function () { if (Anim._gen === gen) peelPile(srcPile, 220); }, i * stag);
      }
    }
  }

  function runHandFlip(s, dur) {
    dockHeld();
    const l = Anim.layer();
    const n = s.cards.length;
    if (!n) return;
    const hand = anchorRect({ anchor: "hand-" + s.player });
    const seats = [];
    for (let i = 0; i < n; i++) seats.push(anchorRect(s.at[i]) || hand);
    const base = hand || seats.find(function (r) { return !!r; });
    if (!base) return;

    const gap = 8;
    let w = 76;
    const maxW = window.innerWidth * 0.8;
    if (n * w + (n - 1) * gap > maxW) w = Math.max(46, Math.floor((maxW - (n - 1) * gap) / n));
    const h = Math.round(w * 1.4);
    const total = n * w + (n - 1) * gap;
    const cx = base.left + base.width / 2;
    const x0 = Math.round(clamp(cx - total / 2, 12, Math.max(12, window.innerWidth - total - 12)));
    const toward = base.top + base.height / 2 < window.innerHeight / 2 ? 1 : -1;
    const cy = Math.round(clamp(base.top + base.height / 2 + toward * h * 0.9, h / 2 + 12, window.innerHeight - h / 2 - 12));
    const spread = Math.min(7, 18 / n);

    const riseMs = Math.round(dur * 0.24);
    const holdEnd = Math.round(dur * 0.8);
    const backMs = Math.round(dur * 0.16);
    const stag = Math.min(STAG.deal, Math.round(riseMs * 0.28));

    if (s.text) {
      const cap = document.createElement("div");
      cap.className = "fxrevealcap";
      setText(cap, s.text);
      cap.style.top = (cy - h / 2 - 30) + "px";
      l.appendChild(cap);
      play(cap, [
        { opacity: 0 }, { opacity: 1, offset: 0.08 },
        { opacity: 1, offset: 0.86 }, { opacity: 0 },
      ], { duration: dur, easing: "ease", fill: "forwards" });
      later(function () { cap.remove(); }, dur + 60);
    }

    for (let i = 0; i < n; i++) {
      const card = s.cards[i];
      const seat = seats[i] || base;
      const rot = n === 1 ? 0 : (i - (n - 1) / 2) * spread;
      const restL = x0 + i * (w + gap);
      const restT = cy - h / 2 + Math.abs(i - (n - 1) / 2) * (h * 0.05);
      const dx = seat.left + seat.width / 2 - (restL + w / 2);
      const dy = seat.top + seat.height / 2 - (restT + h / 2);
      const k0 = seat.width ? clamp(seat.width / w, 0.3, 2) : 1;

      const box = document.createElement("div");
      box.className = "fxrevealcard";
      box.style.width = w + "px";
      box.style.height = h + "px";
      box.style.left = restL + "px";
      box.style.top = restT + "px";
      box.style.opacity = "1";
      const float = document.createElement("div");
      float.className = "fxfloat";
      const inner = document.createElement("div");
      inner.className = "flipinner";
      const front = document.createElement("div");
      front.className = "flipface";
      if (RB.hasArt(card)) {
        front.style.backgroundImage = RB.artCssAt(card, 112);
        front.style.backgroundSize = "cover";
        front.style.backgroundPosition = "center";
      }
      const back = document.createElement("div");
      back.className = "flipface backside";
      inner.appendChild(front);
      inner.appendChild(back);
      float.appendChild(inner);
      box.appendChild(float);
      l.appendChild(box);

      if (Anim.flat()) {
        play(box, [{ opacity: 1 }, { opacity: 1, offset: 0.9 }, { opacity: 0 }],
          { duration: dur, fill: "both" });
        later(function () { box.remove(); }, dur + 40);
        continue;
      }

      const riseAt = i * stag;
      const backAt = holdEnd + (n - 1 - i) * STAG.collect;

      play(box, [
        { opacity: 1, transform: tf(dx, dy, 0, k0), easing: EASE.peel },
        { opacity: 1, transform: tf(dx * 0.4, dy * 0.4 - h * 0.06, rot * 0.5, (k0 + 1) / 2), offset: 0.55, easing: EASE.settle },
        { opacity: 1, transform: tf(0, 0, rot, 1) },
      ], { duration: riseMs, delay: riseAt, fill: "both" });

      play(inner, flipFrames(s.flip !== false), { duration: riseMs, delay: riseAt, fill: "both" });

      play(float, [
        { transform: "translateY(0)" },
        { transform: "translateY(-3px)", offset: 0.3 },
        { transform: "translateY(1px)", offset: 0.65 },
        { transform: "translateY(0)" },
      ], {
        duration: Math.max(400, holdEnd - riseAt - riseMs), delay: riseAt + riseMs,
        easing: "ease-in-out", iterations: 1, fill: "backwards",
      });

      play(box, [
        { opacity: 1, transform: tf(0, 0, rot, 1), easing: EASE.arc },
        { opacity: 1, transform: tf(dx * 0.4, dy * 0.4 - h * 0.04, rot * 0.5, (k0 + 1) / 2), offset: 0.5, easing: EASE.fall },
        { opacity: 1, transform: tf(dx, dy, 0, k0), offset: 0.9 },
        { opacity: 0, transform: tf(dx, dy, 0, k0) },
      ], { duration: backMs, delay: backAt, fill: "forwards" });

      play(inner, flipFrames(s.flip === false), { duration: backMs, delay: backAt, fill: "forwards" });

      later(function () { box.remove(); }, dur + 80);
    }
  }

  function hiddenSelector(key) {
    return String(key).charAt(0) === "@"
      ? "[data-fxkey='" + key + "']"
      : "[data-iid='" + key + "']";
  }

  function arriveExtra(e) {
    if (e.classList.contains("pilearrival")) {
      const slot = e.closest ? e.closest(".bigslot") : null;
      const plate = slot ? slot.querySelector(".slotplate") : null;
      if (plate && e.getAttribute("data-plate")) plate.textContent = e.getAttribute("data-plate");
      const stale = slot ? slot.querySelectorAll(".pilecard.held") : [];
      for (let i = 0; i < stale.length; i++) stale[i].remove();
      play(e, [
        { transform: "translateY(-6px) scale(1.04)" },
        { transform: "none" },
      ], { duration: 200, easing: EASE.settle });
      return;
    }
    if (e.classList.contains("chainitem")) {
      play(e, [
        { opacity: 0, transform: "translateX(34px) scale(.94)", borderColor: "#f0c46a", boxShadow: "0 0 22px rgba(240,196,106,.55)" },
        { opacity: 1, transform: "translateX(0) scale(1)", offset: 0.55, easing: EASE.settle },
        { opacity: 1, transform: "translateX(0) scale(1)", borderColor: "", boxShadow: "" },
      ], { duration: 340, easing: EASE.arc });
      return;
    }
    if (e.classList.contains("eqtab")) {
      e.style.transformOrigin = "left center";
      play(e, [
        { transform: "scaleX(0)", opacity: 0 },
        { transform: "scaleX(1)", opacity: 1 },
      ], { duration: 220, easing: EASE.arc });
    }
  }

  function field() {
    const app = typeof document !== "undefined" ? document.getElementById("app") : null;
    const host = app && app.classList.contains("watching") ? document.getElementById("arena") : null;
    const r = host && host.getBoundingClientRect ? host.getBoundingClientRect() : null;
    if (r && r.width) return { left: r.left, top: r.top, width: r.width, height: r.height };
    return { left: 0, top: 0, width: window.innerWidth, height: window.innerHeight };
  }

  function viewportCenter() {
    const f = field();
    return { x: f.left + f.width / 2, y: f.top + f.height * 0.42 };
  }

  function dockHeld() {
    const box = Anim._held;
    if (!box || box._docked) return;
    const c = viewportCenter();
    const rail = typeof document !== "undefined" ? document.getElementById("chainrail") : null;
    const r = rail && rail.getBoundingClientRect ? rail.getBoundingClientRect() : null;
    const k = 0.6;
    let dx, dy;
    if (r && r.width) {
      dx = Math.round(r.left + r.width / 2 - c.x);
      dy = Math.round(r.top + Math.min(r.height / 2, 96) - c.y);
    } else {
      dx = Math.round(-window.innerWidth * 0.34);
      dy = Math.round(-window.innerHeight * 0.3);
    }
    box._docked = { dx: dx, dy: dy, k: k };
    play(box, [
      { transform: tf(0, 0, 0, 1.15), opacity: 1 },
      { transform: tf(dx, dy, 0, k), opacity: 0.94 },
    ], { duration: 240, easing: EASE.settle, fill: "forwards" });
    if (box._dim) {
      play(box._dim, [{ opacity: 1 }, { opacity: 0 }], { duration: 100, fill: "forwards" });
      const dim = box._dim;
      box._dim = null;
      later(function () { dim.remove(); }, 140);
    }
  }
  Anim.dockHeld = dockHeld;

  Object.assign(AX, { LATER_WHEN: LATER_WHEN, mkBanner: mkBanner, buildCard: buildCard, sheenFrames: sheenFrames, runArc: runArc, runHoldArc: runHoldArc, runSpawn: runSpawn, runMorph: runMorph, domainColor: domainColor, runShuffle: runShuffle, runRevealFan: runRevealFan, runHandFlip: runHandFlip, hiddenSelector: hiddenSelector, arriveExtra: arriveExtra, viewportCenter: viewportCenter, dockHeld: dockHeld });
})();
